import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  pure: false
})
export class SortByPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public transform(array: any[] | null, field?: string): any[] {
    if (!Array.isArray(array) || array.length <= 1) {
      return array || [];
    }   

    if (field) {
      return array.slice().sort((a, b) => a[field].localeCompare(b[field]));
    } else if (typeof array[0] === 'string') {
      return array.slice().sort((a, b) => a.localeCompare(b));
    } else {
      return array;
    }
  }
}
